import { useCallback, useMemo } from "react"

import { Route, Routes, useMatch } from "react-router-dom"

import { ImageCollectionLayer, ImageSelectedLayer, useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { NetworkReferentialLayer, useNavigateToLinearLocation, useNetworksDispatchContext } from "@l2r-front/l2r-networks"

import { API_MODULE_DOCUMENT, APP_DOCUMENT, MODULE_DOCUMENTS, NETWORK_ATTACHMENT } from "../../constants/modules"
import { LINEAR_LOCATION_END, LINEAR_LOCATION_START, TYPE_ID } from "../../constants/urlParams"
import { DocumentAttachedObjectLayer } from "../../containers/DocumentAttachedObjectLayer"
import { DocumentsLayer } from "../../containers/DocumentsLayer"

export const DocumentMapRouter = () => {
    const matchRoad = useMatch(`:slugId/${APP_DOCUMENT}/${MODULE_DOCUMENTS}/:road/*`)
    const matchDetail = useMatch(`:slugId/${APP_DOCUMENT}/${MODULE_DOCUMENTS}/:road/attached/:attachmentType/*`)
    const road = matchRoad?.params?.road ? decodeURIComponent(matchRoad.params.road) : null
    const isSegmentView = !!matchRoad
    const isDetailView = !!matchDetail

    const navigateToLinearLocation = useNavigateToLinearLocation()
    const { setSegmentFeatureIdClicked } = useImageCollectionDispatchContext()
    const { setSelectedLinearLocations } = useNetworksDispatchContext()

    const processNavigation = useCallback((feature, location, navigationOrigin) => {
        if (location && location.road && location.road !== road) {
            setSegmentFeatureIdClicked(feature?.properties?.uuid)
            setSelectedLinearLocations(feature)
            navigateToLinearLocation(location, `./${MODULE_DOCUMENTS}`, { paramsToRemove: [LINEAR_LOCATION_END, LINEAR_LOCATION_START, TYPE_ID], saveMapBoundingBox: !isSegmentView, navigationOrigin: navigationOrigin })
        }
    }, [setSegmentFeatureIdClicked, setSelectedLinearLocations, navigateToLinearLocation, isSegmentView, road])

    const layers = useMemo(() => {
        return (
            <>
                <NetworkReferentialLayer module={API_MODULE_DOCUMENT} processNavigation={processNavigation} />
                <DocumentsLayer />
                {isSegmentView && <ImageCollectionLayer road={road} />}
                {isSegmentView && <ImageSelectedLayer />}
                {isDetailView && <DocumentAttachedObjectLayer />}
            </>
        )
    }, [isDetailView, isSegmentView, processNavigation, road])

    return (
        <Routes>
            <Route
                element={layers}
                path={`/${MODULE_DOCUMENTS}/`}
            />
            <Route
                element={layers}
                path={`/${MODULE_DOCUMENTS}/:road/*`}
            />
            <Route
                element={layers}
                path={`/${MODULE_DOCUMENTS}/attached/${NETWORK_ATTACHMENT}`}
            />
            <Route
                element={layers}
                path={`/${MODULE_DOCUMENTS}/:road/attached/:attachmentType/:attachmentId/*`}
            />
        </Routes>
    )
}